<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardHeader>
          <CCol>
            <strong>Recruitment Details</strong>
            <back-to-list></back-to-list>
          </CCol>
        </CCardHeader>
        <CCardBody>
          <CTabs add-tab-classes="mt-1">
            <span
                @click="selected = 'Details'"
                v-if="checkPermission('list-job-opening')"
            >
              <CTab active>
                <template slot="title">
                  {{ $lang.recruitments.tab.details }}
                </template>
              </CTab>
            </span>
            <span
                @click="selected = 'RecruitmentMedia'"
                v-if="checkPermission('list-job-opening')"
            >
              <CTab>
                <template slot="title">
                  {{ $lang.recruitments.tab.media }}
                </template>
              </CTab>
            </span>
            <span
                @click="selected = 'RecruitmentResponse'"
                v-if="checkPermission('list-job-opening')"
            >
              <CTab>
                <template slot="title">
                  {{ $lang.recruitments.tab.response }}
                </template>
              </CTab>
            </span>
            <span
                @click="selected = 'RecruitmentReport'"
                v-if="checkPermission('list-job-opening')"
            >
              <CTab>
                <template slot="title">
                  {{ $lang.recruitments.tab.report }}
                </template>
              </CTab>
            </span>
          </CTabs>
          <component
              :is="selected"
              style="margin-top: 20px"
              v-bind:recruitmentId="currentId"
              v-bind:profileId="profileId"
              @changeSelected="getTab($event)"
          ></component>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import {Mixin} from "/src/mixins/index.js";
import Details from "./tab/Details";
import RecruitmentMedia from "./tab/RecruitmentMedia";
import RecruitmentReport from "./tab/RecruitmentReport";
import RecruitmentResponse from "./tab/RecruitmentResponse";
import BackToList from "../backToList.vue";

export default {
  name: "RecruitmentsView",
  mixins: [Mixin],
  components: {
    Details,
    RecruitmentMedia,
    RecruitmentReport,
    RecruitmentResponse,
    BackToList,
  },
  data() {
    return {
      userId: "",
      selected: "Details",
      currentId: "",
      profileId: "",
    };
  },
  methods: {
    backToList(userId) {
      if (userId != null) {
        this.$router.push({path: "/profile/all/" + userId});
      }
    },
    getTab(tab) {
      let self = this;
      self.selected = tab;
    },
  },
};
</script>
<style>
div .error {
  color: #ff0000;
}

.hasError label {
  color: red;
}
</style>

